import * as stylex from "@stylexjs/stylex";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { AspectRatioContainer } from "../../components/aspect-ratio";
import { useMedia, useRTL } from "../../hooks";
import { breakpoints, colors, layoutAreas } from "../../materials/consts.stylex";
import { gridCenteredMaxWidthAreas, layout } from "../../materials/layout.stylex";
import { themeVars } from "../../materials/theme.stylex";
import { typography } from "../../materials/typography.stylex";
const image1 = new URL("../../assets/link-boxes/bg_gem.jpeg", import.meta.url).href;
const image2 = new URL("../../assets/link-boxes/bg_peer.jpeg", import.meta.url).href;
const image3 = new URL("../../assets/link-boxes/bg_view.png", import.meta.url).href;
const image4 = new URL("../../assets/link-boxes/bg_wide.jpg", import.meta.url).href;
const styles = {
    root: {
        kBCFzs: "x1lx81y2",
        kWkggS: "x6cgz0f",
        kMwMTN: "x1mqxbix",
        kmVPX3: "xggk2y7 x1qs66ub",
        $$css: true
    },
    title: {
        kLKAdn: "x1p5oq8j",
        kGO01o: "xzk7aed",
        k63SB2: "x1s688f",
        $$css: true
    },
    link: {
        kMwMTN: "x14rmvc5",
        k1xSpc: "xya0591",
        kGuDYH: "x1jchvi3",
        k63SB2: "x1s688f",
        $$css: true
    },
    linkBox: {
        kMwMTN: "x1rbwscb",
        kmVPX3: "xggk2y7",
        kWkggS: "x12peec7",
        k1xSpc: "x78zum5",
        kXwgrk: "xdt5ytf xdjzykv",
        kmkexE: "x1acidej",
        kGVxlE: "x1bgqt54",
        "--link-reveal-color": "x17ebzlu xudin8j",
        "--link-reveal-display": "x15al0pq xs0xzfa",
        kwh8RV: "x1aaofjt",
        kbUV5U: "x4e98wh",
        kHJEeJ: "xx7804x",
        $$css: true
    }
};
export function RelatedContent() {
    const intl = useIntl();
    const screenLDown = !useMedia(breakpoints.l);
    const isRTL = useRTL();
    const ratio = screenLDown ? [
        3,
        1
    ] : [
        1,
        1
    ];
    const offsetY = screenLDown ? -100 : 0;
    return <div {...stylex.props(layout.gridCenteredMaxWidth, styles.root)} data-skip-search>
      <div className="x1yedbjw xdt5ytf x78zum5 xl56j7k x6s0dn4 x1bd1j73">
        <h2 {...stylex.props(typography.heading1, styles.title)}>
          {intl.formatMessage(defineMessage({
        id: "Related content",
        defaultMessage: "Related content"
    }))}
        </h2>
        <div className="x1lx81y2 xh8yej3 xrvj5dj x9myrww x1s97thw xfimi1p">
          <a href={intl.formatMessage(defineMessage({
        id: "url.gem-report-home",
        defaultMessage: "https://www.unesco.org/gem-report/en"
    }))}>
            <div {...stylex.props(typography.heading2, styles.linkBox)}>
              <div className="x2lah0s x4pfjvb" role="presentation">
                <AspectRatioContainer ratio={ratio} offsetY={offsetY}>
                  <img className="xh8yej3" src={image1} alt=""/>
                </AspectRatioContainer>
              </div>
              <div {...{
        0: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1uhho1l xto3oe7 x1xpa7k"
        },
        1: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1xpa7k xl09ye4 x1uhho1l"
        }
    }[!!isRTL << 0]}>
                <h2>
                  <FormattedMessage id="GEM Report website" defaultMessage="GEM Report website"/>
                </h2>
                <p {...stylex.props(typography.body2, styles.link)}>
                  <FormattedMessage id="Learn more" defaultMessage="Learn more"/>
                </p>
              </div>
            </div>
          </a>

          <a href={intl.formatMessage(defineMessage({
        id: "url.education-profiles",
        defaultMessage: "https://education-profiles.org/"
    }))}>
            <div {...stylex.props(typography.heading2, styles.linkBox)}>
              <div className="x2lah0s x4pfjvb" role="presentation">
                <AspectRatioContainer ratio={ratio} offsetY={offsetY}>
                  <img className="xh8yej3" src={image2} alt=""/>
                </AspectRatioContainer>
              </div>
              <div {...{
        0: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1uhho1l xto3oe7 x1xpa7k"
        },
        1: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1xpa7k xl09ye4 x1uhho1l"
        }
    }[!!isRTL << 0]}>
                <h2>
                  <FormattedMessage id="Profiles Enhancing Education Reviews" defaultMessage="Profiles Enhancing Education Reviews"/>
                </h2>

                <p {...stylex.props(typography.body2, styles.link)}>
                  <FormattedMessage id="Learn more" defaultMessage="Learn more"/>
                </p>
              </div>
            </div>
          </a>

          <a href={intl.formatMessage(defineMessage({
        id: "url.education-estimates",
        defaultMessage: "https://education-estimates.org/"
    }))}>
            <div {...stylex.props(typography.heading2, styles.linkBox)}>
              <div className="x2lah0s x4pfjvb" role="presentation">
                <AspectRatioContainer ratio={ratio} offsetY={offsetY}>
                  <img className="xh8yej3" src={image3} alt=""/>
                </AspectRatioContainer>
              </div>
              <div {...{
        0: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1uhho1l xto3oe7 x1xpa7k"
        },
        1: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1xpa7k xl09ye4 x1uhho1l"
        }
    }[!!isRTL << 0]}>
                <h2>
                  <FormattedMessage id="Visualizing Indicators of Education for the World" defaultMessage="Visualizing Indicators of Education for the World"/>
                </h2>

                <p {...stylex.props(typography.body2, styles.link)}>
                  <FormattedMessage id="Learn more" defaultMessage="Learn more"/>
                </p>
              </div>
            </div>
          </a>

          <a href={intl.formatMessage(defineMessage({
        id: "url.education-inequalities",
        defaultMessage: "https://www.education-inequalities.org"
    }))}>
            <div {...stylex.props(typography.heading2, styles.linkBox)}>
              <div className="x2lah0s x4pfjvb" role="presentation">
                <AspectRatioContainer ratio={ratio} offsetY={offsetY}>
                  <img className="xh8yej3" src={image4} alt=""/>
                </AspectRatioContainer>
              </div>
              <div {...{
        0: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1uhho1l xto3oe7 x1xpa7k"
        },
        1: {
            className: "x78zum5 xdt5ytf xl56j7k x1p5oq8j xlxyvcp x1xpa7k xl09ye4 x1uhho1l"
        }
    }[!!isRTL << 0]}>
                <h2>
                  <FormattedMessage id="World Inequality Database on Education" defaultMessage="World Inequality Database on Education"/>
                </h2>
                <p {...stylex.props(typography.body2, styles.link)}>
                  <FormattedMessage id="Learn more" defaultMessage="Learn more"/>
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>;
}
